export default {"src":"/_next/static/media/printable-drawing-grid-guide.8572dcfc.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};